interface CertificationThumbnailProps {
  thumbnail?: string | null;
  alt?: string;
  className?: string;
}

export function CertificationThumbnail({
  thumbnail,
  alt = "Certificate thumbnail",
  className = "",
}: CertificationThumbnailProps) {
  if (!thumbnail) {
    return (
      <div
        className={`bg-gray-100 border border-gray-200 flex items-center justify-center ${className}`}
      >
        <span className="text-gray-400 text-sm">No thumbnail</span>
      </div>
    );
  }

  return (
    <img src={thumbnail} alt={alt} className={`object-cover ${className}`} />
  );
}
